/**
 * Time-of-day helpers that avoid Date ISO parsing and leftover seconds/ms.
 * react-datepicker can stamp the current seconds/milliseconds onto a selected
 * time; subtracting those Dates then Math.floor() yields 1h 59m instead of 2h 0m.
 */

const TIME_BASE_YEAR = 2000;
const TIME_BASE_MONTH = 0;
const TIME_BASE_DAY = 1;

export function parseTimeToDate(val) {
  if (val instanceof Date) {
    if (isNaN(val.getTime())) return '';
    return new Date(TIME_BASE_YEAR, TIME_BASE_MONTH, TIME_BASE_DAY, val.getHours(), val.getMinutes(), 0, 0);
  }

  if (typeof val === 'string' && val.trim()) {
    const match = val.trim().match(/(\d{1,2}):(\d{2})/);
    if (!match) return '';
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) return '';
    return new Date(TIME_BASE_YEAR, TIME_BASE_MONTH, TIME_BASE_DAY, hours, minutes, 0, 0);
  }

  return '';
}

export function normalizeTimeDate(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return date || '';
  return new Date(TIME_BASE_YEAR, TIME_BASE_MONTH, TIME_BASE_DAY, date.getHours(), date.getMinutes(), 0, 0);
}

export function calculateTimeDuration(startVal, endVal) {
  const start = parseTimeToDate(startVal);
  const end = parseTimeToDate(endVal);
  if (!(start instanceof Date) || !(end instanceof Date)) return null;

  let diffMinutes = (end.getHours() * 60 + end.getMinutes()) - (start.getHours() * 60 + start.getMinutes());
  if (diffMinutes < 0) diffMinutes += 24 * 60;

  return {
    hours: Math.floor(diffMinutes / 60),
    minutes: diffMinutes % 60,
  };
}

export function formatTimeForApi(val) {
  if (val instanceof Date && !isNaN(val.getTime())) {
    const hours = String(val.getHours()).padStart(2, '0');
    const minutes = String(val.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  return val || '';
}
